export default "__VITE_ASSET__d2dac2fc__"